import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { YardMap } from './yard-map.model';

@Injectable({
  providedIn: 'root'
})
export class YardMapService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getYardMap(mapName: string): Observable<YardMap> {
    return this.appServerAPI.execute('/client/control/yardmap', mapName);
  }

}
